export default "dist/images/block-column-plain.02a24e9.png";